var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 12,
    viewBox: "0 0 41 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5303 6.05328C40.8232 5.76039 40.8232 5.28551 40.5303 4.99262L35.7574 0.219648C35.4645 -0.073245 34.9896 -0.073245 34.6967 0.219648C34.4038 0.512542 34.4038 0.987415 34.6967 1.28031L38.9393 5.52295L34.6967 9.76559C34.4038 10.0585 34.4038 10.5334 34.6967 10.8263C34.9896 11.1191 35.4645 11.1191 35.7574 10.8263L40.5303 6.05328ZM0 5.52295V6.27295H40V5.52295V4.77295H0V5.52295Z",
    fill: "#101820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLong);
export default __webpack_public_path__ + "static/media/arrow-long.23a7a2eb61bae36b87321c597d625496.svg";
export { ForwardRef as ReactComponent };